<template>
  <div class="wrapper pa-4">
    <h1>
      交融泡泡
    </h1>
    <p>
      对比度交融：让亮的更亮，暗色的更暗。
    </p>
    <p>
      全透明 => 模糊 => 半透明 => 对比度
    </p>
    <div class="d-flex">
      <div class="container1">
        <div class="ball" />
        <div class="ball" />
      </div>
      <div class="container1">
        <div class="ball2" />
        <div class="ball2" />
      </div>
      <div class="container2">
        <div class="ball3" />
        <div class="ball3" />
      </div>
    </div>
    <highlightjs
      :code="contrastblend"
      :language="'css'"
    />
    <p>
      2个泡泡对比度交融，父元素背景色必须是区别子元素颜色才行，父元素背景没有颜色就失效了
    </p>
    <div class="container3">
      <div class="ball" />
      <div class="ball" />
    </div>
    <highlightjs
      :code="contrastblendfail"
      :language="'css'"
    />

    <p />
    <hr>
    <p />
    <p>2个泡泡透明度交融： 使用svg滤镜</p>
    <p>
      全透明 => 模糊 => 半透明 => 透明度保留
    </p>
    <div class="d-flex">
      <div class="box">
        <div class="ballsvg" />
        <div class="ballsvg" />
      </div>
    </div>
    <highlightjs
      :code="svgblend"
      :language="'css'"
    />

    <div
      style="border: 1px solid;"
      class="my-2"
    >
      <p>
        可以隐藏svg <code>display: none;</code>
      </p>
      <svg
        id="svg"
        width="100"
        height="100"
      >
        <circle
          cx="50"
          cy="50"
          r="40"
          stroke="black"
          stroke-width="3"
          fill="red"
        />
        <defs>
          <filter id="sbsb">
            <!-- 定义模糊滤镜 入参SourceGraphic原始像素点 用高斯模糊feGaussianBlur 10个像素 -->
            <feGaussianBlur
              in="SourceGraphic"
              stdDeviation="10"
              result="blur"
            />
            <!-- 入参上次blur运算结果 进行矩阵运算 -->
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="
              1 0 0 0 0
              0 1 0 0 0
              0 0 1 0 0
              0 0 0 20 -5
              "
            />
          </filter>
        </defs>
      </svg>
      <p>SVG代码：</p>
      <highlightjs
        :code="svg"
        lang="html"
      />
    </div>

    <p />
    <p>参考:</p>
    <p><a href="https://developer.mozilla.org/en-US/docs/Web/SVG/Element/feColorMatrix">https://developer.mozilla.org/en-US/docs/Web/SVG/Element/feColorMatrix</a></p>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        contrastblend: `.ball {
  background: #000;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  filter: blur(5px);
}

.container1 {
  background: #fff;
  filter: contrast(10);
}`,
        contrastblendfail: `.ball {
  background: #000;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  filter: blur(5px);
}
.container3 {
  filter: contrast(10);
}`,
        svgblend: `// 子元素画圆
.ballsvg {
  background: #7de53d;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

// 父元素应用svg的滤镜
.box {
  filter: url(#sbsb);
}`,
        svg: `<svg
  id="svg"
  width="100"
  height="100"
>
  <circle
    cx="50"
    cy="50"
    r="40"
    stroke="black"
    stroke-width="3"
    fill="red"
  />
  <defs>
    <filter id="sbsb">
      <!-- 定义模糊滤镜 入参SourceGraphic原始像素点 用高斯模糊feGaussianBlur 10个像素 -->
      <feGaussianBlur
        in="SourceGraphic"
        stdDeviation="10"
        result="blur"
      />
      <!-- 入参上次blur运算结果 进行矩阵运算 -->
      <feColorMatrix
        in="blur"
        mode="matrix"
        values="
        1 0 0 0 0
        0 1 0 0 0
        0 0 1 0 0
        0 0 0 20 -5
        "
      />
    </filter>
  </defs>
</svg>`,
      }
    },
  }
</script>

<style lang="scss" scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

.ball {
  background: #000;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  filter: blur(5px);
}

.container1 {
  background: #fff;
  filter: contrast(10);
}

.ball2 {
  background: tomato;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  filter: blur(5px);
}

.ball3 {
  background: #fff;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  filter: blur(5px);
}

.container2 {
  background: #000;
  filter: contrast(10);
}

.container3 {
  filter: contrast(10);
}

// 子元素画圆
.ballsvg {
  background: #7de53d;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

// 父元素应用svg的滤镜
.box {
  filter: url(#sbsb);
}
</style>